export default function HomeFooter() {
  const quickLinks = ["Home", "Rooms", "Amenities", "Testimonials", "Contact"]

  return (
    <footer className="bg-slate-900 text-white">
      <div className="max-w-7xl mx-auto px-8 py-12">
        <div className="grid sm:grid-cols-2 md:grid-cols-4 gap-10">
          {/* BRAND */}
          <div>
            <img
              className="w-32"
              src="/images/icons/STAY-SUITE_LOGO-V1.webp"
              alt=""
            />

            <p className="text-slate-300 text-sm leading-relaxed mt-4">
              Comfortable and affordable rooms designed for students,
              professionals, and long-term tenants.
            </p>
          </div>

          {/* QUICK LINKS */}
          <div>
            <h3 className="font-semibold text-lg mb-4">Quick Links</h3>

            <ul className="space-y-2">
              {quickLinks.map((link) => (
                <li key={link}>
                  <a
                    href="#"
                    className="text-slate-300 text-sm hover:text-orange-500 transition"
                  >
                    {link}
                  </a>
                </li>
              ))}
            </ul>
          </div>

          {/* CONTACT */}
          <div>
            <h3 className="font-semibold text-lg mb-4">Contact Us</h3>

            <ul className="space-y-2 text-slate-300 text-sm">
              <li>📍 Manila, Philippines</li>
              <li>📞 0912 345 6789</li>
              <li>✉️ staysuite@email.com</li>
            </ul>
          </div>

          {/* CTA / SOCIAL */}
          <div>
            <h3 className="font-semibold text-lg mb-4">Need a Room?</h3>

            <p className="text-slate-300 text-sm mb-4">
              Send us an inquiry and we’ll help you find the right unit.
            </p>

            <button className="bg-orange-500 px-6 py-3 rounded-md font-semibold hover:bg-orange-600 transition">
              Send Inquiry
            </button>
          </div>
        </div>

        {/* BOTTOM */}
        <div className="border-t border-slate-700 mt-10 pt-6 text-center">
          <p className="text-slate-400 text-sm">
            © {new Date().getFullYear()} StaySuite. All rights reserved.
          </p>
        </div>
      </div>
    </footer>
  )
}
